<script>
export default {
    name: "AppointmentDetails",

    data() {

        return {
            patient: {},
            appointments: [],
        };
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchPatientDetails(), this.fetchAppointments(),]).then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchPatientDetails() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.query.patient}`;

            return this.$http.get(url).then(({data}) => {
                this.patient = data.length ? data[0] : {};
            }).catch(() => {});
        },

        fetchAppointments() {
            let url = `MedicalFile/GetSpecificPatientAppointment`;
                url += `?ID=${this.$route.query.appointment}`;

            return this.$http.get(url).then(({ data }) => {
                this.appointments = data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="w-full flex flex-wrap items-center">
    <tail-address-header></tail-address-header>
    <div class="w-full flex flex-wrap mt-3">
        <div class="w-full p-1 text-center">
            <h5 class="font-medium">Appointment</h5>
        </div>
        <div class="w-1/3 p-1">
          <h5 class="font-semibold text-sm">Patient: 
              <span class="text-sm">{{ patient.names }}</span></h5>
        </div>
        <div class="w-1/3 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">MRN: </span>
            <span class="font-semibold">{{ patient.patienT_ID || ' -' }}</span></h5>
        </div>
        <div class="w-1/3 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Id No/Passport: </span>
            <span class="font-semibold text-sm">{{ patient.nationalid || " -" }}</span></h5>
        </div>
        <div class="w-1/3 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">IP File No: </span>
            <span class="font-semibold">{{ patient.ipfileno || ' -' }}</span></h5>
        </div>
        <div class="w-1/3 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">OP File No: </span>
            <span class="font-semibold">{{ patient.opfileno || ' -'}}</span></h5>
        </div>
        <div class="w-1/3 p-tiny">
          <h5 class="text-sm"><span class="font-semibold">Cellphone: </span>
            <span class="font-semibold">{{patient.celL_PHONE || " -" }}</span></h5>
        </div>
    </div>
    <div class="w-full overflow-visible mt-4">
        <table class="table text-xs border">
            <thead>
                <tr>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Clinic</th>
                    <th class="p-tiny">Doctor</th>
                    <th class="p-tiny w-1/6">Comment</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="appointment in appointments" :key="appointment.id">
                    <td class="p-tiny">{{ appointment.date | dateFormat }}</td>
                    <td class="p-tiny">{{ appointment.clinic }}</td>
                    <td class="p-tiny">{{ appointment.doctor }}</td>
                    <td class="p-tiny w-1/6 break-words">{{ appointment.comment || `-` }}</td>
                </tr>
            </tbody>
        </table> 
    </div>
</div>
</template>